import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_chip_group = _resolveComponent("v-chip-group")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_card, { elevation: 4 }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, null, {
        default: _withCtx(() => [
          _createTextVNode("Other Demographics")
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_text, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { justify: "center" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                elevation: 4,
                class: "rounded-lg"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_chip_group, {
                            modelValue: _ctx.choices,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.choices) = $event)),
                            column: "",
                            color: "primary",
                            multiple: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_chip, {
                                filter: "",
                                variant: "outlined"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Visually Impaired ")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_chip, {
                                filter: "",
                                variant: "outlined"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Hearing Impaired ")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_chip, {
                                filter: "",
                                variant: "outlined"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Organ Donor ")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode(_component_v_switch, {
                            modelValue: _ctx.deceased,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.deceased) = $event)),
                            label: "Deceased",
                            color: "primary",
                            "hide-details": "",
                            inset: ""
                          }, null, 8, ["modelValue"]),
                          (_ctx.deceased)
                            ? (_openBlock(), _createBlock(_component_v_text_field, {
                                key: 0,
                                label: "Date of Death",
                                variant: "outlined",
                                density: "comfortable",
                                type: "date",
                                color: "primary"
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.deceased)
                            ? (_openBlock(), _createBlock(_component_v_text_field, {
                                key: 1,
                                label: "Time of Death",
                                variant: "outlined",
                                density: "comfortable",
                                type: "time",
                                color: "primary"
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}